/** Reviewed wire layouts: Jac0xb/lighthouse 4c579479c98635e419b1b167f08be02a71604a71
 * programs/lighthouse/src/types/assert.
 * Support account-info and token-account assertions, including bounded multi
 * forms. Unknown handlers fail closed; memory and compression are never allowed.
 */
export const LIGHTHOUSE_PROGRAM = "L2TExMFKdjpN9kozasaurPirfHy9P8sbXoAN1qA3S95";
export const ASSERTION_PACKET_RESERVE = 192;
export const APPROVAL_COMPUTE_UNITS = 400_000;
export function validLighthouseAssertion(data, accountCount) {
    try {
        let at = 0;
        const byte = () => { if (at >= data.length)
            throw Error(); return data[at++]; };
        const take = (n) => { if (at + n > data.length)
            throw Error(); at += n; };
        const bounded = (max) => { if (byte() > max)
            throw Error(); };
        const compact = () => {
            let n = 0n, shift = 0n;
            for (let i = 0; i < 10; i++) {
                const b = byte();
                n |= BigInt(b & 127) << shift;
                if (!(b & 128)) {
                    if (n > 0xffffffffffffffffn || i && b === 0)
                        throw Error();
                    return n;
                }
                shift += 7n;
            }
            throw Error();
        };
        const opcode = byte(), log = byte();
        if (accountCount !== 1 || log > 6 || ![5, 6, 9, 10].includes(opcode))
            return false;
        const info = () => {
            const variant = byte();
            if ([0, 1, 4].includes(variant)) {
                take(8);
                bounded(7);
            }
            else if (variant === 2) {
                take(32);
                bounded(1);
            }
            else if (variant === 3) {
                bounded(8);
                bounded(1);
            }
            else if ([5, 6, 7].includes(variant)) {
                bounded(1);
                bounded(1);
            }
            else if (variant === 8) {
                take(32);
                compact();
                compact();
            }
            else
                throw Error();
        };
        const token = () => {
            const variant = byte();
            if ([0, 1].includes(variant)) {
                take(32);
                bounded(1);
            }
            else if ([2, 6].includes(variant)) {
                take(8);
                bounded(7);
            }
            else if ([3, 5, 7].includes(variant)) {
                const present = byte();
                if (present > 1)
                    throw Error();
                if (present)
                    take(variant === 5 ? 8 : 32);
                bounded(1);
            }
            else if (variant === 4) {
                bounded(2);
                bounded(7);
            }
            else if (variant !== 8)
                throw Error();
        };
        const count = [6, 10].includes(opcode) ? Number(compact()) : 1;
        if (!Number.isSafeInteger(count) || count < 1 || count > 32)
            return false;
        for (let i = 0; i < count; i++)
            (opcode < 9 ? info : token)();
        return at === data.length;
    }
    catch {
        return false;
    }
}
